// export default routes
import Login from "../controllers/Login/Login";
import ResetPassword from "../controllers/ResetPassword/ResetPassword";
import Settings from "../controllers/Settings/Settings";
import notFound from "./notFound";
import unauthorized from "./unauthorized";
import { filteredRoutesByModules } from "./manageRouting";
import SetNewPassword from "../controllers/SetNewPassword/SetNewPassword";
import userProjectsByOrganizations from "./userProjectsByOrganization";
import ChangePassword from "../controllers/ChangePassword/ChangePassword";
import SSOCallback from "../controllers/Login/SSOCallback";
import SAMLCallback from "../controllers/Login/SAMLCallback";
import packageAssociation from "./packageAssociation";
import forbidden from "./forbidden";

const defaultRoutes = [
    {
        path: "/",
        component: Login,
        exact: true,
    },
    {
        path: "/:locale(pt|en|lt|es|ro|fr)?/login",
        component: Login,
        exact: true,
    },
    {
        path: "/:locale(pt|en|lt|es|ro|fr)?/start",
        component: Login,
        exact: true,
    },
    {
        path: "/v1/oidc/uri_callback",
        component: SSOCallback,
        exact: true,
    },
    {
        path: "/v1/saml/uri_callback",
        component: SAMLCallback,
        exact: true,
    },
    {
        path: "/:locale(pt|en|lt|es|ro|fr)?/my_profile/reset_password",
        component: SetNewPassword,
        exact: false,
    },
    {
        path: "/:locale(pt|en|lt|es|ro|fr)?/reset_password",
        component: ResetPassword,
        exact: true,
    },
    {
        path: "/:locale(pt|en|lt|es|ro|fr)?/change_password/:tokenAccess",
        component: ChangePassword,
        exact: true,
    },
    userProjectsByOrganizations("/:locale(pt|en|lt|es|ro|fr)?", [], true, "Organizations"),
    userProjectsByOrganizations(
        "/:locale(pt|en|lt|es|ro|fr)?/organizations/:organizationId",
        [],
        true,
        "Organizations",
    ),
    {
        path: "/:locale(pt|en|lt|es|ro|fr)?/settings/:section?",
        component: Settings,
        exact: true,
    },
    packageAssociation(
        "/:locale(pt|en|lt|es|ro|fr)?/settings/:section/packages-association/:id/:entity?",
        [],
        true,
        "label(PackageAssociation)",
        false,
    ),
    notFound("/:locale(pt|en|lt|es|ro|fr)?/organizations/:organizationId/*"),
    notFound("/:locale(pt|en|lt|es|ro|fr)?/not_found"),
    unauthorized("/:locale(pt|en|lt|es|ro|fr)?/unauthorized"),
    forbidden("/:locale(pt|en|lt|es|ro|fr)?/forbidden"),
];

const filteredRoutes = (modules) => {
    let getFilteredRoutes = filteredRoutesByModules(modules);

    return [
        ...defaultRoutes,
        ...getFilteredRoutes,
        notFound("/:locale(pt|en|lt|es|ro|fr)?/:projectId?/:fiscalYear([0-9]{4}|current)?/*"),
        forbidden("/:locale(pt|en|lt|es|ro|fr)?/:projectId?/:fiscalYear([0-9]{4}|current)?/*"),
    ];
};

export { filteredRoutes, defaultRoutes };
